'use strict';

/**
 * Breadcrumb collection-context enhancer.
 *
 * Captures the originating collection on click of a product card link
 * (`a[data-bs-product-link]`) and stores it in sessionStorage. On product
 * pages the stored context is injected into the server-rendered
 * breadcrumbs nav using the data-* hooks from `snippets/breadcrumbs.liquid`.
 * Cards rendered without collection context (homepage, search, related
 * products, etc.) carry the marker without handle attributes and clear
 * the storage on click, so the breadcrumb stays accurate.
 */
(() => {
  const KEY = 'bs_breadcrumb_collection_source';

  const session = {
    get() { try { return sessionStorage.getItem(KEY); } catch (_) { return null; } },
    set(value) { try { sessionStorage.setItem(KEY, value); } catch (_) { /* noop */ } },
    remove() { try { sessionStorage.removeItem(KEY); } catch (_) { /* noop */ } },
  };

  const handleCardClick = (event) => {
    const link = event.target.closest('a[data-bs-product-link]');
    if (!link) return;

    const handle = link.getAttribute('data-bs-collection-handle');
    if (!handle) {
      session.remove();
      return;
    }

    session.set(JSON.stringify({
      handle,
      title: link.getAttribute('data-bs-collection-title') || '',
      url: link.getAttribute('data-bs-collection-url') || '',
    }));
  };

  const readContext = () => {
    const raw = session.get();
    if (!raw) return null;
    try {
      const data = JSON.parse(raw);
      return data && data.handle && data.url ? data : null;
    } catch (_) {
      session.remove();
      return null;
    }
  };

  const injectCrumb = (context) => {
    const nav = document.querySelector('nav.breadcrumbs[data-bs-breadcrumbs]');
    const currentRow = nav && nav.querySelector('[data-bs-breadcrumb-current]');
    if (!currentRow || nav.dataset.bsBreadcrumbsEnhanced === '1') return;

    const crumb = document.createElement('li');
    crumb.setAttribute('data-bs-breadcrumb-collection', '');
    const link = document.createElement('a');
    link.href = context.url;
    link.className = 'breadcrumbs__link';
    link.textContent = context.title || context.handle;
    crumb.appendChild(link);

    const separator = document.createElement('li');
    separator.className = 'breadcrumbs__separator';
    separator.textContent = '/';

    currentRow.before(crumb, separator);
    nav.dataset.bsBreadcrumbsEnhanced = '1';
  };

  const init = () => {
    // Capture phase ensures the click is recorded before navigation starts.
    document.addEventListener('click', handleCardClick, true);

    if (!/\/products\/[^/?#]+/.test(window.location.pathname)) return;
    const context = readContext();
    if (context) injectCrumb(context);
    // Storage is intentionally kept so back/forward navigation keeps the crumb.
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
